import * as React from "react";
import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileArchive = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "2 2 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m20.03 7.72-5.25-5.25a.75.75 0 0 0-.53-.22h-9a1.5 1.5 0 0 0-1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-12a.75.75 0 0 0-.22-.53M15 4.81l2.69 2.69H15zm3.75 15.44H10.5v-1.5h.75a.75.75 0 1 0 0-1.5h-.75v-1.5h.75a.75.75 0 1 0 0-1.5h-.75v-1.5h.75a.75.75 0 1 0 0-1.5h-.75v-.75a.75.75 0 1 0-1.5 0v.75h-.75a.75.75 0 1 0 0 1.5H9v1.5h-.75a.75.75 0 1 0 0 1.5H9v1.5h-.75a.75.75 0 1 0 0 1.5H9v1.5H5.25V3.75h8.25v4.5a.75.75 0 0 0 .75.75h4.5z"
	})
});
const Memo = memo(SvgFileArchive);
export default Memo;
